import React from 'react'

const TextArea = React.forwardRef((props, ref) => (
  <label className='registration-label'>
    {props.label}
    {props.desc && <span className='registration-label__desc'>{props.desc}</span>}
    <textarea {...props} ref={ref} className='registration-control' rows={props.rows || '3'}></textarea>
    {props.error && <div className='error_container'>{props.error.message}</div>}
  </label>
))

export default TextArea
